import { useQuery } from "react-query";
import { getAgentsPlans } from "./agents-plans-service";

export const useGetAgentsPlans = (sponsor: string, config?: any) => {
  return useQuery(["agents/plans", sponsor], () => getAgentsPlans(sponsor), {
    enabled: !!sponsor,
    ...config,
  });
};
